export const VideoCropStatus = {
	CREATED:    'created',
	BUILDING:   'building',
	PROCESSING: 'processing',
	AVAILABLE:  'available',
	FAILED:     'failed',
};
